import gql from 'graphql-tag';
import FieldsRoom from "graphql/fields/FieldsRoom";
import FieldsTimeslot from "graphql/fields/FieldsTimeslot";
import HelperGraphql from 'utils/helper-graphql'

const fields = {
	'kind': 'String',
	'sub_kind': 'String',
	'timeslot_day': '[Int]',
};

export default gql(`
	query rooms( ${ HelperGraphql.createFields( fields ) } ) {
		rooms {
			${FieldsRoom}
	        
	        tables {
				guid
			}
			
			floor {
				guid
			}
			
			timeslots_through( ${ HelperGraphql.createVariables( fields ) } ) {
                ${FieldsTimeslot}
            }
		}
	}
`);

